const isRealTimeTestSegment = segmentName => segmentName.startsWith('cait-realtime-test')
;

export { isRealTimeTestSegment }
;
